// import { Component } from '@angular/core';
import { Component, OnInit, Inject, HostListener } from "@angular/core";
import { Router } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { CryptographyService } from "../services/cryptography.service";

import { AddendumService } from "../services/addendum.service";

import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AdminService } from "../services/admin.service";
import { Country } from "../models/country";
import { AOWGroup } from "../models/aowgroup";
import { UserRoleEnum } from "../core/constant";


@Component({
  selector: "app-view-as-different-role",
  templateUrl: "./view-as-different-role.component.html",
  styleUrls: ["./view-as-different-role.component.scss"],
})
export class ViewAsDifferentRoleComponent implements OnInit {
  selectedCountryID: any;
  loading: boolean = false;
  countries: Country[] = [];
  filteredCountries: Country[] = [];
  countrySearchText: string = "";
  isCountryDropdownOpen: boolean = false;

  selectedAOWgrp: number;
  aowGroups: AOWGroup[] = [];
  filteredAowGroups: AOWGroup[] = [];
  aowSearchText: string = "";
  isAowDropdownOpen: boolean = false;

  selectedRole: string = "";
  role: number;
  error: string = "";

  constructor(
    private adminService: AdminService,
    private addendumService: AddendumService,
    private router: Router,
    @Inject(LOCAL_STORAGE)
    public storage: WebStorageService,
    private cryptographyService: CryptographyService,
    private ngbModal: NgbModal
  ) {}

  ngOnInit() {
    this.getMasterData();
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest(".mcd-filter-dropdown-wrapper")) {
      this.isCountryDropdownOpen = false;
      this.isAowDropdownOpen = false;
    }
  }

  selectRole(role: string) {
    if (this.selectedRole !== "" && this.selectedRole !== role) {
      return;
    }

    if (role === "Market Admin") {
      this.selectedRole = role;
      this.role = UserRoleEnum.MarketAdmin;
    } else if (role === "AOW Admin") {
      this.selectedRole = role;
      this.role = UserRoleEnum.AOWAdmin;
    } else {
      this.selectedRole = role;
      this.role = UserRoleEnum.BasicUser;
    }
  }

  resetSelection() {
    this.selectedRole = "";
    this.role = 0;
    this.selectedCountryID = null;
    this.selectedAOWgrp = null;
    this.isCountryDropdownOpen = false;
    this.isAowDropdownOpen = false;
  }

  toggleCountryDropdown() {
    this.isCountryDropdownOpen = !this.isCountryDropdownOpen;
    this.isAowDropdownOpen = false;
    this.countrySearchText = "";
    this.filterCountries();
  }

  toggleAowDropdown() {
    this.isAowDropdownOpen = !this.isAowDropdownOpen;
    this.isCountryDropdownOpen = false;
    this.aowSearchText = "";
    this.filterAowGroups();
  }

  filterCountries() {
    if (!this.countrySearchText) {
      this.filteredCountries = [...this.countries];
    } else {
      const query = this.countrySearchText.toLowerCase();
      this.filteredCountries = this.countries.filter((c) =>
        c.name.toLowerCase().includes(query)
      );
    }
  }

  filterAowGroups() {
    if (!this.aowSearchText) {
      this.filteredAowGroups = [...this.aowGroups];
    } else {
      const query = this.aowSearchText.toLowerCase();
      this.filteredAowGroups = this.aowGroups.filter((g) =>
        g.groupName.toLowerCase().includes(query)
      );
    }
  }

  selectCountryItem(country: Country) {
    this.selectedCountryID = country.id;
    this.isCountryDropdownOpen = false;
  }

  selectAowItem(group: AOWGroup) {
    this.selectedAOWgrp = group.id;
    this.isAowDropdownOpen = false;
  }

  getSelectedCountryName(): string {
    if (!this.selectedCountryID) return "Select";
    const found = this.countries.find((c) => c.id === this.selectedCountryID);
    return found ? found.name : "Select";
  }

  getSelectedAowName(): string {
    if (!this.selectedAOWgrp) return "Select";
    const found = this.aowGroups.find((g) => g.id === this.selectedAOWgrp);
    return found ? found.groupName : "Select";
  }

  viewAsRole() {
    this.loading = true;
    if (this.selectedRole === "Market Admin" && !this.selectedCountryID) {
      alert("Please select Country");
      this.loading = false;
      return;
    }

    if (
      this.selectedRole === "AOW Admin" &&
      (!this.selectedCountryID || !this.selectedAOWgrp)
    ) {
      alert("Please select both Country and AOW Group");
      this.loading = false;
      return;
    }

    if (this.selectedRole === "Basic User" && !this.selectedCountryID) {
      alert("Please select Country");
      this.loading = false;
      return;
    }

    sessionStorage.setItem("impersonationView", "true");
    sessionStorage.setItem(
      "userRoleId",
      this.cryptographyService.encryptData(this.role)
    );
    sessionStorage.setItem(
      "selectedCountryID",
      JSON.stringify(this.selectedCountryID)
    );
    this.router
      .navigate(["/locations"])
      .then(() => window.location.reload());
  }

  getMasterData() {
    this.loading = true;
    this.adminService.getMasterDataForAddEditUser().subscribe(
      (data: any) => {
        this.countries = data.countries
          ? data.countries.map((country: any) => new Country(country))
          : [];
        this.filteredCountries = [...this.countries];
        this.aowGroups = data.aowGroups
          ? data.aowGroups.map((aowGroup: any) => new AOWGroup(aowGroup))
          : [];
        this.filteredAowGroups = [...this.aowGroups];
        this.loading = false;
      },
      (error: string) => {
        this.loading = false;
      }
    );
  }
}
